import React, { useState, useEffect, useRef} from 'react'
import NavbarReturn from '../components/NavbarReturn';
import FooterAdmin from '../components/FooterAdmin';
import { Toaster } from 'react-hot-toast';
import AlertBox from '../components/AlertBox';
import { collection, getDocs, setDoc, doc, updateDoc, deleteDoc} from "firebase/firestore";
import { database } from "../config/firebaseConfig";
import AlertOnLoading from '../components/AlertOnLoading';
import { storage } from '../config/firebaseConfig';
import {ArrowUpTrayIcon} from '@heroicons/react/24/outline';
import { v4 } from 'uuid';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { XMarkIcon } from "@heroicons/react/24/outline";

function AboutUsAdmin() {

    const WAIT_TIME = 1000; //Waits for 2s
    const notInitialRender = useRef(false);

    const SUCCESS = "success"
    const WARNING = "warning"
    const DANGER = "danger"

    const [newData, setNewData] = useState(true);
    const [newDataWorkers, setNewDataWorkers] = useState(true);

    const workersCollectionRef = collection(database, "workers");
    
    const [usDescription, setDescription] = useState("");
    const [usMission, setMission] = useState("");
    const [usVision, setVision] = useState("");

    const [workerPosition, setWorkerPosition] = useState("");
    const [workerName, setWorkerName] = useState("");
    const [imageSelected, setImageSelected] = useState("Imagen");
    
    const [imageUpload, setImageUpload] = useState(null);
    const [imageURL, setImageURL] = useState('');

    const [aboutUs, setAboutUs] = useState(null);
    const [workers, setWorkers] = useState(null);

    const [workerIdSelected, setWorkerIdSelected]= useState('');

    function updateText(event) {
        setImageUpload(event.target.files[0]);
        console.log(imageUpload);
        const newText = document.getElementById("uploadImage").value;
        const getFileName = newText.split("\\");
        setImageSelected(getFileName[getFileName.length - 1]);
    }

    /*
        It shows the PopUp of the news
    */
    const togglePopUpWorker = (workerId, name, position, image) => {
        const popup = document.getElementById(workerId);
        popup.classList.remove('hidden');
        popup.classList.add('flex');
        setWorkerName(name);
        setWorkerPosition(position);
        setImageURL(image);
        setWorkerIdSelected(workerId);
    }

    const togglePopupDelete = (workerId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${workerId}`),function(itm){
          itm.style.display = "flex";
        })();
    }

    const closePopupDelete = (workerId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${workerId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    /*
    It hides the PopUp of the news
    */
    const closePopUpWorker = (workerId) => {
        const popup = document.getElementById(workerId);
        setWorkerName('');
        setImageURL('');
        setWorkerPosition('');
        setWorkerIdSelected('');
        setImageSelected('Imagen');
        popup.classList.add('hidden');
        popup.classList.remove('flex');
    }

    /*
    It updates the text of the image's input for PopUp
    */
    function updateTextPopUp(event) {
        setImageUpload(event.target.files[0]);
        const newText = event.target.files[0];
        const getFileName = newText.name;
        setImageSelected(getFileName);
    }

    async function saveAboutUs() {
        if (usDescription === "") {
            AlertBox(WARNING, '¡Debe ingresar una descripción!')
            return;

        } else if (usMission === "") {
            AlertBox(WARNING, '¡Debe ingresar la misión!');
            return;

        } else if (usVision === "") {
            AlertBox(WARNING, '¡Debe ingresar la visión!');
            return;

        } else {
            const newAboutUsRef = doc(database, "aboutUs", aboutUs[0].id);
            await updateDoc(newAboutUsRef, {description: usDescription, mission: usMission, vision: usVision});

            setDescription("");
            setMission("");
            setVision("");
            AlertBox(SUCCESS, '¡Sección de Nosotros actualizada correctamente!');
        }
    }

    async function addWorker() {
        if (workerName === "") {
            AlertBox(WARNING, '¡Debe ingresar el nombre del colaborador!')
            console.log(sessionStorage.getItem("Query"));
            return;

        } else if (workerPosition === "") {
            AlertBox(WARNING, '¡Debe indicar un cargo para el colaborador!');
            return;

        } else if (imageUpload === null) {
            AlertBox(WARNING, '¡Debe seleccionar una imagen!');
            return;

        } else {
            const imageRef = await ref(storage, `images/${imageUpload.name + v4()}`);
            uploadBytes(imageRef, imageUpload).then(async () => {
    
                const imageURL = await getDownloadURL(imageRef);
                const newWorkerRef = doc(workersCollectionRef);
                setDoc(newWorkerRef, {name: workerName, position:workerPosition, image:imageURL});

                console.log("Documento creado exitosamente");
                AlertBox(SUCCESS, 'Colaborador agregado exitosamente');

                setImageSelected("Imagen");
                setWorkerName("");
                setWorkerPosition("");
                setImageUpload(null);
                setNewDataWorkers(true);
                
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen ", error)
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                return;
            });
        }
    }

    /*
    Updates a news document
    */
    async function updateWorker() {
        if (imageSelected !== "Imagen") {
            const imageRef = await ref(storage, `images/${imageUpload.name}`);
            uploadBytes(imageRef, imageUpload).then(async () => {
                const imageURL = await getDownloadURL(imageRef);
                const updateWorkerRef = doc(database, 'workers', workerIdSelected);
                await updateDoc(updateWorkerRef, {name:workerName, position:workerPosition, image: imageURL});

                setImageSelected("Imagen");
                setWorkerName("");
                setWorkerPosition("");
                setNewDataWorkers(true);
                AlertBox(SUCCESS, '¡Colaborador actualizado correctamente!');
                closePopUpWorker(workerIdSelected);
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen")
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                return;
            });
        } else {
            const updateWorkerRef = doc(database, 'workers', workerIdSelected);
            await updateDoc(updateWorkerRef, {name:workerName, position:workerPosition, image: imageURL});

            setImageSelected("Imagen");
            setWorkerName("");
            setWorkerPosition("");
            setNewDataWorkers(true);
            AlertBox(SUCCESS, '¡Colaborador actualizado correctamente!');
            closePopUpWorker(workerIdSelected);
            return;
        }
        
    }

    /*
    Deletes a news document
    */
    async function deleteWorker(workerId) {
        const workerDoc = doc(database, "workers", workerId);
        await deleteDoc(workerDoc);
        setNewDataWorkers(true);
        closePopupDelete(workerId);
        AlertBox(SUCCESS, '¡Colaborador eliminado correctamenteeee!');
    }

    /*
    Gets aboutUs current info
    */
    useEffect(() => {
        if (notInitialRender.current && newData){
            AlertOnLoading(WAIT_TIME+100);
            
        } else {
            notInitialRender.current = true;
        }

        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const aboutUsRef = collection(database, "aboutUs");
                
                const getAboutUs = async() => {
                    const data = await getDocs(aboutUsRef);
                    setAboutUs(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                    
                }
                getAboutUs();
                setNewData(!newData);

                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [aboutUs, newData])

    /*
    Gets all workers
    */
    useEffect(() => {
        if (notInitialRender.current && newDataWorkers){
            //AlertOnLoading(WAIT_TIME+100);
        } else {
            notInitialRender.current = true;
        }

        const interval = setInterval(() => { //Autorize re-render
            if (newDataWorkers) {
                const workersRef = collection(database, "workers");
                
                const getWorkers = async() => {
                    const data = await getDocs(workersRef);
                    setWorkers(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                    
                }
                getWorkers();
                setNewDataWorkers(!newDataWorkers);

                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [workers, newDataWorkers])

  return (
    <div>

        <div>
        <Toaster
        toastOptions={{
            duration:3000,
        }}/>

        </div>

        <NavbarReturn />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>

        <div className='px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
            <h2 className='lg:text-xl'>Sección Sobre Nosotros</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
        </div>

        <div className='px-4 py-0 w-full h-auto flex flex-row bg-white'>

            <div className='flex flex-col space-y-4 px-4 py-6 '>

                <div className=''>
                    <textarea  className='h-text-area-height py-2 px-3 w-64 md:w-72 lg:w-input-web text-sm sm:text-base text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none' 
                    id="usDescription" name="usDescription" rows="7" cols="41" placeholder="Descripción"
                    onChange={(event) => {setDescription(event.target.value)}} value={usDescription}></textarea>
                </div>

                <div className=''>
                    <textarea  className='h-text-area-height py-2 px-3 w-64 md:w-72 lg:w-input-web text-sm sm:text-base text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none' 
                    id="usMission" name="usMission" rows="7" cols="41" placeholder="Misión"
                    onChange={(event) => {setMission(event.target.value)}} value={usMission}></textarea>
                </div>

                <div className='sm:hidden'>
                    <textarea  className='h-text-area-height py-2 px-3 w-64 md:w-72 lg:w-input-web sm:hidden text-sm sm:text-base text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none' 
                    id="usVision" name="usVision" rows="7" cols="41" placeholder="Visión"
                    onChange={(event) => {setVision(event.target.value)}} value={usVision}></textarea>
                </div>

                <div>
                    <button className='h-8 w-64 md:w-72 lg:w-input-web text-sm sm:text-base sm:h-9 bg-primary-100 mt-0 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                    onClick={saveAboutUs}>Guardar</button>
                </div>

            </div>

            <div className='hidden sm:flex sm:flex-col sm:h-32 sm:space-y-2.5 sm:px-4 sm:py-6 sm:w-80 bg-white'>
            
                <div>
                    <textarea className='py-2 px-3 w-48 sm:w-64 md:w-72 lg:w-input-web h-text-area-height text-sm sm:text-base text-input-font bg-primary-300
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none'
                            id="usVision" name="usVision" rows="3" cols="41" placeholder="Visión"
                            onChange={(event) => {setVision(event.target.value)}} value={usVision}></textarea>
                </div>

            </div>
            
        </div>

        <div className='px-4 flex flex-col w-full h-full bg-white'>
            <h2 className='lg:text-xl mt-10'>Colaboradores</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
        </div>

        <div className='px-4 py-0 w-full h-auto flex flex-row bg-white'>

            <div className='flex flex-col space-y-4 px-4 py-6'>

                <div>
                    <input onChange={(event) => {setWorkerPosition(event.target.value)}} value={workerPosition} type={"text"} placeholder="Cargo"
                        className='text-sm md:text-base w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>

                <div>
                    <input onChange={(event) => {setWorkerName(event.target.value)}} value={workerName} type={"text"} placeholder="Nombre"
                        className='text-sm md:text-base w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>

                <div>
                    <div className='relative h-input-height w-64 md:w-72 lg:w-input-web py-1 px-3 overflow-hidden
                        text-placeholder bg-primary-300 focus:outline-none
                        focus:border focus:border-primary-100 focus:shadow-md'>
                        <label htmlFor="image" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm sm:text-base`}>{imageSelected}</label>

                        <div className='absolute inset-y-0 right-0 flex items-center'>
                            <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                        </div>

                        <input onChange={updateText} id="uploadImage" className='absolute file:w-full opacity-0 cursor-pointer left-0' 
                        aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg"/>
                    </div>
                </div>

                <div>
                    <button className='h-8 w-64 md:w-72 lg:w-input-web text-sm sm:text-base sm:h-9 bg-primary-100 mt-0 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                    onClick={addWorker}>Agregar</button>
                </div>

            </div>

        </div>

        <div className='px-4 flex flex-col w-full h-full bg-white'>
            <h2 className='lg:text-xl mt-10'>Todos los colaboradores</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
        </div>

        <div className='w-full flex flex-row justify-center bg-white pb-6 min-h-[30vh]'>
            <div className='w-full flex flex-col justify-center items-center bg-white'>
                {workers?.map((worker)=> (
                    <div className='w-full flex justify-center' key={worker.id}>
                        <div key={worker.id} className='max-w-table-web w-4/5 p-2 gap-2 grid grid-rows-8 mt-6 border border-primary-100 sm:flex sm:flex-col'>
                            <div className='hidden sm:grid grid-cols-2 gap-2'>
                                
                                <div className='flex flex-col space-y-2'>
                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Nombre</h3>
                                    </div>

                                    <div className='bg-background w-full h-9 flex justify-center items-center'>
                                        <p className='text-navFont-100 text-base lg:text-xl'>{worker.name}</p>
                                    </div>

                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Cargo</h3>
                                    </div>

                                    <div className='bg-background w-full h-9 flex justify-center items-center'>
                                        <p className='text-navFont-100 text-sm lg:text-lg'>{worker.position}</p>
                                    </div>

                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Acción</h3>
                                    </div>

                                    <div className='w-full h-9 flex justify-center items-center bg-background space-x-2'>

                                        <div className='w-1/3'>
                                            <button onClick={() => {togglePopUpWorker(worker.id, worker.name, worker.position, worker.image)}}
                                            className='w-full h-7 text-sm lg:text-base sm:h-9 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar</button>
                                        </div>

                                        <div className='w-1/3 flex items-end'>
                                            <button onClick={() => {togglePopupDelete(worker.id)}}
                                            className='w-full h-7 text-sm lg:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar</button>
                                        </div>

                                    </div>
                                </div>

                                <div className='flex flex-col space-y-2'>
                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Imagen</h3>
                                    </div>

                                    <div className='bg-background w-full max-h-[212px] h-full flex justify-center items-center'>
                                        <LazyLoadImage src={worker.image} className='w-full h-full max-h-[212px] object-cover object-center'
                                        alt=''></LazyLoadImage>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='sm:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Nombre</h3>
                            </div>

                            <div className='sm:hidden bg-background w-full h-9 flex justify-center items-center'>
                                <h3 className='text-navFont-100 text-base'>{worker.name}</h3>
                            </div>

                            <div className='sm:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Cargo</h3>
                            </div>

                            <div className='sm:hidden bg-background w-full h-9 flex justify-center items-center'>
                                <h3 className='text-navFont-100 text-base font-sm'>{worker.position}</h3>
                            </div>

                            <div className='sm:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Imagen</h3>
                            </div>

                            <div className='sm:hidden bg-background w-full h-auto flex justify-center items-center'>
                                <LazyLoadImage src={worker.image} className='w-full h-auto object-top object-cover'
                                alt=''></LazyLoadImage>
                            </div>

                            <div className='sm:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Acción</h3>
                            </div>

                            <div className='sm:hidden w-full h-9 flex justify-center items-center bg-background space-x-2'>

                                <div className='bg-background w-1/2 h-9 flex justify-center items-center'>
                                    <button onClick={() => {togglePopUpWorker(worker.id, worker.name, worker.position, worker.image)}} 
                                    className='w-full h-9 text-sm lg:text-base sm:h-9 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar</button>
                                </div>

                                <div className='bg-background w-1/2 h-9 flex justify-center items-center'>
                                    <button onClick={() => {togglePopupDelete(worker.id)}} 
                                    className='w-full h-9 text-sm lg:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar</button>
                                </div>

                            </div>
                        </div>

                        <div className={`hidden fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`} id={worker.id}> 
                            <div className='relative sm:max-w-2xl w-full flex flex-col justify-center py-3 items-center mx-10 sm:mx-5 sm:px-3 h-auto bg-white rounded overflow-y-auto'>
                                <div className='w-full flex flex-col items-center justify-center mt-3'>
                                    <h2 className='flex flex-row md:text-xl'>Editar Colaborador</h2>
                                    <span className='md:w-80 w-48 h-px border border-primary-100'></span>
                                </div>
                                <button onClick={() => {closePopUpWorker(worker.id)}} className='absolute top-1 right-1 hover:text-primary-100'><XMarkIcon className='w-7 h-7'/></button>
                                <div className='sm:static sm:space-x-3 sm:items-start sm:flex-row relative w-full flex flex-col justify-center py-3 items-center mx-0 h-auto bg-white rounded overflow-y-auto'>
                                    <div className='w-full flex flex-col items-center justify-center'>
                                        

                                        <div className='w-52 mt-3 sm:w-5/6'>
                                            <input type={"text"} placeholder="Nombre" onChange={(ev) => {setWorkerName(ev.target.value)}} value={workerName}
                                            className='md:text-base text-sm w-full h-8 py-2 px-3 text-input-font bg-primary-300
                                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md border-none'/>
                                        </div>

                                        <div className='w-52 mt-3 sm:w-5/6'>
                                            <input type={"text"} placeholder="Nombre" onChange={(ev) => {setWorkerPosition(ev.target.value)}} value={workerPosition}
                                            className='md:text-base text-sm w-full h-8 py-2 px-3 text-input-font bg-primary-300
                                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md border-none'/>
                                        </div>

                                        <div className='relative w-52 h-8 py-1 px-3 overflow-hidden sm:w-5/6 border-none
                                            text-input-font bg-primary-300 focus:outline-none 
                                            focus:border focus:border-primary-100 focus:shadow-md mt-3'>
                                            <label htmlFor="image" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm sm:text-base`}>{imageSelected}</label>
                                            <div className='absolute inset-y-0 right-0 flex items-center'>
                                                <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                                            </div>
                                            <input onChange={updateTextPopUp} id="uploadImage" className='absolute file:w-full opacity-0 cursor-pointer left-0' 
                                            aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg" />
                                        </div>

                                        <div className='w-52 mt-1 flex flex-col bg-primary-300 py-2 px-3 sm:w-5/6 max-h-72'>
                                            <h4 className='sm:text-base text-sm text-input-font'>Imagen anterior:</h4>
                                            <LazyLoadImage className='h-60 w-auto object-contain object-top' src={imageURL} alt="">
                                            </LazyLoadImage>
                                        </div>

                                    </div>

                                </div>
                                <div className='w-52 mt-3 flex flex-row'>
                                    <button onClick={updateWorker} className='w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold hover:bg-primary-200'>Guardar</button>
                                </div>
                            </div>
                        </div>

                        <div className={`hidden relative z-40 popup_delete ${worker.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                            <div className="fixed inset-0 bg-popup"></div>

                            <div className="fixed inset-0 z-10 overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                        <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                            </svg>
                                        </div>
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                            <div className="mt-2">
                                            <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                        <button onClick={() => {deleteWorker(worker.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                        <button onClick={() => {closePopupDelete(worker.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>

        <FooterAdmin />
    </div>
  )
}

export default AboutUsAdmin